import PropTypes from "prop-types";
import { useEffect, useState } from "react";

export default function TableOfContents({ data = [] }) {
  const headings = data;
  const [activeHeading, setActiveHeading] = useState("");

  useEffect(() => {
    const handleScroll = () => {
      let current = "";

      if (headings?.allItems) {
        for (const heading of headings.allItems) {
          const element = document.getElementById(heading.id);
          if (element && element.getBoundingClientRect().top < 73 + 48)
            current = heading.id;
        }
        setActiveHeading(String(current));
      }
    };
    handleScroll();

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [headings]);

  return (
    <>
      <div className="c-heading--caps font-medium text-gray-600 mb-3">
        On this page
      </div>

      <ul data-role="on-this-page" className="text-sm text-gray-700 space-y-1">
        {headings.withLevels?.length === 0 && (
          <li className="text-gray-600 italic">No subsections</li>
        )}

        {headings.withLevels?.map(({ id, title, items }, index) => (
          <li key={`${id}-${index}`}>
            <a
              href={`#${id}`}
              className={`inline-block py-1 no-underline hover:text-blue transition duration-300 ${
                id == activeHeading ? "text-blue font-medium" : ""
              }`}
            >
              {title}
            </a>

            {items?.length >= 0 && (
              <ul className="pl-5 my-2 space-y-1 border-l border-gray-200">
                {items.map(({ id, title }, childIndex) => (
                  <li key={`${id}-${index}-${childIndex}`}>
                    <a
                      href={`#${id}`}
                      className={`inline-block py-1 no-underline hover:text-blue transition duration-300 ${
                        id == activeHeading ? "text-blue font-medium" : ""
                      }`}
                    >
                      {title}
                    </a>
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </>
  );
}

TableOfContents.propTypes = {
  data: PropTypes.shape({
    allItems: PropTypes.array,
    withLevels: PropTypes.array,
  }),
};
